<template>
    <form class="form-horizontal" v-if="id_rastreador">
        <table>
            <tr>
                <td style=" padding-right: 30px">
                    <button @click="embarcarRfidVitana()" type="button" class="btn btn-sm btn-success">
                        <i class="fa fa-save"></i> EMBARCAR RFID
                    </button>
                </td>
                <td style="padding-right: 30px">
                    <button @click="removerRfidVitana()" type="button" class="btn btn-sm btn-danger">
                        <i class="fa fa-save"></i> REMOVER RFID
                    </button>
                </td>
                <td style=" padding-right: 30px">
                    <button @click="removerAllRfidVitana()" type="button" class="btn btn-sm btn-danger">
                        <i class="fa fa-save"></i> REMOVER TODOS OS RFID
                    </button>
                </td>
            </tr>
        </table>
    </form>
</template>
<script>
    import { Bus } from '../../../../class/bus';
    import { Vitana } from '../../../../class/vitana';
    export default {
        name: "RfidVitana",
        props: {
            id_rastreador: {
                default: null
            }
        },
        methods: {
            embarcarRfidVitana (id_rastreador) {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Vitana.embarcarRFID(this.id_rastreador);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            },
            removerRfidVitana (id_rastreador) {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente remover um RFID?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, desejo remover!'
                }).then(async () => {
                    try {
                        await Vitana.removerRFID(this.id_rastreador);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            },
            removerAllRfidVitana (id_rastreador) {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente remover TODOS os RFID?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, desejo remover!'
                }).then(async () => {
                    try {
                        await Vitana.limparRFID(this.id_rastreador);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.error(err);
                        return toastr.error("Configuração não enviada!");
                    }
                });
            }
        }
    }
</script>
